import { gql } from "@apollo/client";

const schema = {
  delete: {
    name: "deleteOrderStep",
    serviceName: "admin",
    query: gql`
      mutation deleteOrderStep($ids: [String]!) {
        deleteOrderStep(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
